import styled from '@emotion/styled'
import { MultilingualKeyDto } from '@pharmac-extranet/management-api'
import {
  PharmacButton,
  PharmacCheckbox,
  PharmacDropdown,
  PharmacDropdownChevron,
  PharmacDropdownItem,
  PharmacDropdownItems,
  PharmacText,
} from '@pharmac/ui'
import React from 'react'
import { useLanguage } from '../hooks'
import { ExtranetContainer } from './ExtranetContainer'

const DropdownButton = styled(PharmacButton)<{ width?: number }>`
  ${(p) => p.width && `width: ${p.width}px`};
`

const DropdownItem = styled(PharmacDropdownItem)<{ width?: number }>`
  ${(p) => p.width && `width: ${p.width}px`};
`

type MultiSelectData = {
  id: number
  name: MultilingualKeyDto
}

type MultiSelectProps = {
  title: string
  data: MultiSelectData[]
  selected: number[]
  handleSelect: (item: number[]) => void
  width?: number
}

export const MultiSelect = ({ title, data, selected, handleSelect, width }: MultiSelectProps) => {
  const { key } = useLanguage()

  const handleCheckboxChange = (selectedIds: number[], platformId: number) => {
    return selectedIds.find((a) => a === platformId)
      ? selectedIds.filter((a) => a !== platformId)
      : selectedIds.concat([platformId])
  }

  return (
    <PharmacDropdown
      handle={({ isVisible }: any) => (
        <DropdownButton
          width={width}
          fullWidth
          variant="secondary"
        >
          <ExtranetContainer spaceBetween>
            {title}
            <PharmacDropdownChevron isVisible={isVisible} />
          </ExtranetContainer>
        </DropdownButton>
      )}
      yOffset={1}
      xOffset={0}
    >
      <PharmacDropdownItems>
        {data?.map((a) => (
          <React.Fragment key={a.id}>
            {key(a.name) && (
              <DropdownItem
                width={width}
                fullWidth
                key={a.id}
              >
                <ExtranetContainer
                  paddingSmall
                  alignCenter
                  style={{ width: '200px' }}
                >
                  <PharmacCheckbox
                    checked={!!selected.find((selectedId) => selectedId === a.id)}
                    handleChange={() => handleSelect(handleCheckboxChange(selected, a.id))}
                  >
                    <PharmacText>{key(a.name)}</PharmacText>
                  </PharmacCheckbox>
                </ExtranetContainer>
              </DropdownItem>
            )}
          </React.Fragment>
        ))}
      </PharmacDropdownItems>
    </PharmacDropdown>
  )
}
